export const de: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'Dashboard',
  'nav.focus': 'Tagesfokus & Roadmap',
  'nav.ai_assistant': 'Automatisierte Betriebs-Engine',
  'nav.calendar': 'Google Kalender',
  'nav.book': 'Öffentliche Buchungsseite',
  'nav.bookings': 'Buchungen & Einnahmen',
  'nav.invoices': 'Rechnungen',
  'nav.expenses': 'Ausgaben',
  'nav.settings': 'Unternehmens- & Steuer-HQ',
  'nav.billing': 'Abonnement & Pläne',
  'nav.j_lens': 'J-Lens Tresor',
  'nav.concept': 'Konzept & Mentalität',
  'nav.what_is': 'Was ist AzuraOS?',
  'nav.export': 'Export & Sicherung',
  'nav.menu': 'Menü',
  'nav.welcome': 'Willkommen & BYOK-Hub',
  'nav.app_stack_modules': 'Systemmodule',
  'nav.core_engines': '8 Kern-Engines',
  'nav.manifesto': 'Gründersystem & Manifest',
  'nav.workspace_actions': 'Arbeitsbereich-Aktionen',
  'nav.export_records': 'Datensätze exportieren',
  'nav.load_demo': 'Demo-Sandbox laden',
  'nav.partnerships': 'Partnerschaften & Förderung',
  'nav.request_partnership': 'Partnerzugang anfragen',
  'nav.partner_subtext': 'Bankintegrationen, Kohorten & Sponsoring',
  'nav.interface_language': 'Benutzeroberflächen-Sprache',
  'nav.legal_trust': 'Recht & Sicherheit',
  'nav.security': 'Sicherheit',
  'nav.faqs': 'Häufige Fragen (FAQ)',
  'nav.terms': 'AGB',
  'nav.privacy': 'Datenschutz',
  'nav.refund': 'Rückerstattungsrichtlinie',
  'nav.contact': 'Kontakt',
  'nav.report_bug': 'Fehler melden',
  'nav.invite_founder': '+ Gründer einladen',
  'nav.privacy_active': 'Privatsphäre-Modus: AKTIV',
  'nav.privacy_off': 'Privatsphäre-Modus: AUS',
  'nav.masked': 'Verborgen',
  'nav.visible': 'Sichtbar',
  'nav.live_margin': 'LIVE-BETRIEBSMARGE',
  'nav.target_safe_zone': 'Sicherheitsziel:',
  'nav.close_menu': 'Menü schließen',
  'nav.founder_access': 'Anmelden / Gründerzugang',
  'nav.private_vault': 'Privater Tresor verbunden',
  'nav.master_access': 'Master-Gründerzugang',
  'nav.lifetime': 'Lebenslang',
  'nav.pro_active': 'Souverän Pro Aktiv',
  'nav.trial_days': '7-Tage-Test: {days} Tage verbleibend',
  'nav.trial_expired': 'Testphase abgelaufen',
  'nav.manage': 'Verwalten →',
  'nav.upgrade': 'Upgrade →',
  'nav.unlock_pro': 'Pro freischalten →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'Guten Morgen',
  'dash.greeting_afternoon': 'Guten Tag',
  'dash.greeting_evening': 'Guten Abend',
  'dash.value_prop': 'Mehrkanal-Kontrolle an einem Ort: Geben Sie 1 Einnahme und 1 Ausgabe ein, um Ihre Nettomarge in Echtzeit zu sehen.',
  'dash.manage_streams': 'Einnahmequellen verwalten',
  'dash.close_streams': 'Quellen schließen',
  'dash.income': 'Einnahmen',
  'dash.collected': 'Erhalten',
  'dash.unpaid': 'Ausstehend',
  'dash.expenses': 'Ausgaben',
  'dash.across_records': 'Über alle Datensätze',
  'dash.net_profit': 'Nettogewinn',
  'dash.daily_focus_title': 'Tagesfokus & Umsatzaktionsplan',
  'dash.daily_focus_sub': 'Wichtige Gründeraufgaben zur Gewinn- und Wachstumssteigerung',
  'dash.open_focus': 'Fokus-Roadmap öffnen',
  'dash.stream_profitability': 'Quellen-Rentabilität',
  'dash.stream_sub': '1 Angebot oder mehrere Quellen • Live-Margentool',
  'dash.quick_actions': 'Schnellaktionen',
  'dash.add_booking': 'Buchung hinzufügen',
  'dash.add_booking_desc': 'Neuen Kundenumsatz erfassen',
  'dash.add_expense': 'Ausgabe erfassen',
  'dash.add_expense_desc': 'Betriebs- & Geschäftskosten verbuchen',
  'dash.add_insight': 'Insight hinzufügen',
  'dash.add_insight_desc': 'Neue J-Lens-Regel festhalten',
  'dash.quick_add_title': 'Schnelleingabe',
  'dash.quick_revenue': '+ SCHNELLER UMSATZ (BUCHUNG)',
  'dash.quick_expense': '+ SCHNELLE AUSGABE (HAUPTBUCH)',
  'dash.recent_activity': 'Letzte Aktivitäten',
  'dash.no_activity': 'Noch keine Aktivitäten vorhanden. Nutzen Sie die Schnellaktionen oben.',
  'dash.spotlight_insight': 'Spotlight J-Lens Insight',
  'dash.access_vault': 'Tresor öffnen →',
  'dash.sandbox_active': 'Sandbox aktiv',
  'dash.load_demo_data': 'Demodaten laden',
  'dash.clear_sandbox': 'Sandbox leeren',
  'dash.clear_confirm': 'Daten löschen?',
  'dash.yes_clear': 'Ja, löschen',
  'dash.cancel': 'Abbrechen',

  // Bookings View
  'bookings.title': '📅 Buchungen & Quellen',
  'bookings.subtitle': 'Souveräne Kundeneinnahmequellen',
  'bookings.public_page': 'Öffentliche Buchungsseite',
  'bookings.import_csv': 'CSV importieren',
  'bookings.add_button': 'Buchung hinzufügen',
  'bookings.client_link_title': 'Kunden-Selbstbuchungslink',
  'bookings.client_link_desc': 'Teilen Sie Buchungslinks mit automatischer Google Kalender-Synchronisierung.',
  'bookings.link_active': 'Aktiv',
  'bookings.generate_custom_link': '⚡ Individuellen Preislink erstellen',
  'bookings.hide_custom_link': 'Link ausblenden',
  'bookings.copy_standard_link': 'Standard-Link kopieren',
  'bookings.copied_link': 'Link kopiert!',
  'bookings.preview': 'Vorschau',
  'bookings.search_placeholder': 'Nach Kunde oder Service suchen...',
  'bookings.filter_all': 'Alle Quellen',
  'bookings.table_client': 'Kundenname',
  'bookings.table_stream': 'Quelle / Service',
  'bookings.table_date': 'Datum',
  'bookings.table_amount': 'Betrag',
  'bookings.table_status': 'Status',
  'bookings.table_actions': 'Aktionen',
  'bookings.mark_paid': 'Als bezahlt markieren',
  'bookings.mark_unpaid': 'Als offen markieren',
  'bookings.delete': 'Löschen',
  'bookings.no_records': 'Keine Buchungen gefunden. Nutzen Sie "Buchung hinzufügen" oben.',

  // Invoices View
  'invoices.title': '📄 Kundenrechnungen & Forderungen',
  'invoices.subtitle': 'Professionelle Rechnungsstellung und Zahlungsabgleich',
  'invoices.create_invoice': 'Neue Rechnung erstellen',
  'invoices.tab_all': 'Alle Rechnungen',
  'invoices.tab_paid': 'Bezahlte Rechnungen',
  'invoices.tab_outstanding': 'Ausstehend / Offen',
  'invoices.tab_overdue': 'Überfällig',
  'invoices.table_number': 'Rechnung Nr.',
  'invoices.table_client': 'Kunde',
  'invoices.table_issue_date': 'Ausstellungsdatum',
  'invoices.table_due_date': 'Fälligkeitsdatum',
  'invoices.table_total': 'Gesamtbetrag',
  'invoices.table_status': 'Status',
  'invoices.download_pdf': 'PDF herunterladen',
  'invoices.mark_as_paid': 'Bezahlt',
  'invoices.no_records': 'Noch keine Rechnungen erstellt. Erstellen Sie eine neue Rechnung.',

  // Expenses View
  'expenses.title': '💳 Betriebsausgaben & Hauptbuch',
  'expenses.subtitle': 'Kostenverfolgung und steuerliche Abzugsfähigkeit',
  'expenses.log_expense': 'Ausgabe erfassen',
  'expenses.import_csv': 'CSV importieren',
  'expenses.total_outflow': 'Gesamtausgaben',
  'expenses.tax_deductible': 'Steuerlich absetzbar',
  'expenses.search_placeholder': 'Nach Lieferant oder Zweck suchen...',
  'expenses.filter_all': 'Alle Kategorien',
  'expenses.table_category': 'Kategorie',
  'expenses.table_description': 'Beschreibung / Lieferant',
  'expenses.table_date': 'Datum',
  'expenses.table_claimable': 'Abzugsfähig',
  'expenses.table_amount': 'Betrag',
  'expenses.table_actions': 'Aktionen',
  'expenses.claimable_yes': 'Ja (Absetzbar)',
  'expenses.claimable_no': 'Nein (Privat / Nicht absetzbar)',
  'expenses.no_records': 'Noch keine Ausgaben erfasst. Fügen Sie Kosten hinzu, um echte Margen zu berechnen.',

  // Daily Focus & Roadmap
  'focus.title': '🎯 Tagesfokus & Umsatzaktionsplan',
  'focus.subtitle': 'Wichtige Aufgaben für maximalen Umsatz und operative Dynamik',
  'focus.add_task': 'Umsatzaufgabe hinzufügen',
  'focus.active_tasks': 'Aktive Prioritäten',
  'focus.completed_tasks': 'Erledigte Aufgaben',
  'focus.high_leverage': 'Hohe Priorität',
  'focus.mark_done': 'Als erledigt markieren',
  'focus.delete_task': 'Löschen',
  'focus.no_tasks': 'Alles erledigt! Fügen Sie eine neue Umsatzaufgabe hinzu.',

  // Automated Operational Engine
  'ai.title': '⚡ Automatisierte Betriebs-Engine',
  'ai.subtitle': 'Clientseitig verschlüsselte Berechnungen und Finanzintelligenz (Null Datenspeicherung)',
  'ai.ask_placeholder': 'Fragen Sie nach Cashflow, Margenoptimierung oder Preisstrategie...',
  'ai.send': 'Analysieren',
  'ai.thinking': 'Die Betriebs-Engine verarbeitet Ihre Finanzdaten...',
  'ai.prompt_margin': 'Wie kann ich meine Nettogewinnmarge auf 60 % steigern?',
  'ai.prompt_tax': 'Welche Ausgaben sollte ich für meinen Steuerpuffer geltend machen?',
  'ai.prompt_pricing': 'Wie strukturiere ich monatliche Beratungs-Retainer?',
  'ai.clear_chat': 'Verlauf leeren',

  // Business & Tax HQ
  'hq.title': '🏢 Unternehmens- & Steuer-HQ',
  'hq.subtitle': 'Profil, Währung, Steuervorschriften, Länder-Voreinstellungen und Prüfberichte',
  'hq.tab_profile': 'Profil & Identität',
  'hq.tab_currency_tax': 'Währung & Steuervorschriften',
  'hq.tab_accountant_view': 'Steuerberater- & Wirtschaftsprüfer-Ansicht',
  'hq.tab_exports': 'Exporte & Sicherungen',
  'hq.tab_security': 'Sicherheit & Schutz',
  'hq.jurisdiction_preset_title': 'Regionale Länder-Voreinstellung',
  'hq.jurisdiction_preset_desc': 'Wählen Sie Ihr Land aus, um Landeswährung, USt./MwSt.-Sätze und Finanzamtbezeichnungen automatisch einzustellen.',
  'hq.accountant_view_title': 'Steuerberater- & Wirtschaftsprüfer-Ansicht',
  'hq.accountant_view_desc': 'Standardisiertes Vorbereitungs-Paket für Steuerberater oder Bankprüfungen.',
  'hq.export_pdf_audit': 'Druckbarer Prüfbericht als PDF',
  'hq.export_csv_audit': 'Prüfbericht als CSV exportieren',
  'hq.currency_symbol': 'Währungssymbol',
  'hq.currency_code': 'Währungscode',
  'hq.vat_rate': 'USt./MwSt.-Satz (%)',
  'hq.tax_authority': 'Name des Finanzamts',
  'hq.save_settings': 'Unternehmenseinstellungen speichern',

  // Financial & Metric Labels
  'metric.gross_revenue': 'Bruttoumsatz',
  'metric.total_expenses': 'Gesamtausgaben',
  'metric.net_profit': 'Netto-Betriebsergebnis',
  'metric.profit_margin': 'Betriebsgewinnmarge',
  'metric.active_bookings': 'Aktive Buchungen',
  'metric.paid_invoices': 'Bezahlte Rechnungen',
  'metric.unpaid_invoices': 'Offene Rechnungen',
  'metric.tax_buffer': 'Geschätzter Steuerpuffer',
  'metric.currency': 'Betriebswährung',
  'metric.tax_rate': 'USt./MwSt.-Satz',

  // Actions & Common Buttons
  'btn.save': 'Speichern',
  'btn.cancel': 'Abbrechen',
  'btn.download': 'Herunterladen',
  'btn.export_pdf': 'Bericht als PDF herunterladen',
  'btn.export_csv': 'Als CSV exportieren',
  'btn.cpa_pack': 'Steuerberater-Paket exportieren',
  'btn.new_booking': 'Buchung erfassen',
  'btn.new_expense': 'Ausgabe erfassen',
  'btn.add_task': 'Aufgabe hinzufügen',
  'btn.sync_calendar': 'Google Kalender synchronisieren',
  'btn.privacy_mode': 'Privatsphäre-Modus',
  'btn.manage_subscription': 'Abonnement verwalten',
  'btn.sign_in': 'Anmelden / Zugang',
  'btn.sign_out': 'Abmelden',
  'btn.delete': 'Löschen',
  'btn.edit': 'Bearbeiten',
  'btn.close': 'Schließen',

  // Statuses
  'status.paid': 'Bezahlt',
  'status.unpaid': 'Offen',
  'status.overdue': 'Überfällig',
  'status.safe': 'Gesunde Marge',
  'status.warning': 'Margentool-Warnung',
  'status.trial_active': 'Testphase Aktiv',
  'status.pro_active': 'Souverän Pro',
};
